import { useContext, useEffect, useState } from 'react';
import {
  Modal,
  Backdrop,
  Fade,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  useTheme,
} from '@mui/material';

import { Delete, Close } from '@mui/icons-material';

import api from '../../services/api';
import { AuthContext } from '../../context/Auth/AuthContext';
import { FormatMask } from '../../utils/FormatMask';
import { getStyled } from './styles';

const handleRemoveContactTag = async (contactId, tagId) => {
  await api.delete(`/tags-contacts/${tagId}/${contactId}`);
};

const ContactTagListModal = ({ open, onClose, tag }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [tagList, setTagList] = useState(tag.contacts);
  const { user, socket } = useContext(AuthContext);
  const format = new FormatMask();

  useEffect(() => {
    const onCompanyTags = (data) => {
      if (data.action === 'update' || data.action === 'create') {
        if (data.tag.id === tag.id && data.tag?.contacts?.length > 0) {
          setTagList(data.tag.contacts);
        }
        if (data.tag.id === tag.id && data.tag?.contacts?.length === 0) {
          setTagList([]);
          onClose();
        }
      }
    };
    socket.on(`company${user.companyId}-tag`, onCompanyTags);

    return () => {
      socket.off(`company${user.companyId}-tag`, onCompanyTags);
    };
  }, [socket, user, onClose, tag]);

  return tagList.length > 0 ? (
    <Modal
      sx={classes.modal}
      open={open}
      onClose={onClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <div style={classes.paper}>
          <IconButton sx={classes.closeButton} onClick={onClose}>
            <Close />
          </IconButton>
          <h2 id='transition-modal-title'>#{tag.name} - Contatos</h2>
          <TableContainer component={Paper} sx={classes.table}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center' }}>ID</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>Nome</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>Número</TableCell>
                  <TableCell>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tagList?.map((contact) => (
                  <TableRow key={contact.id}>
                    <TableCell>{contact.id}</TableCell>
                    <TableCell>{contact.name}</TableCell>
                    <TableCell>
                      {format.setPhonePatternMask(contact.number)}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() =>
                          handleRemoveContactTag(contact.id, tag.id)
                        }
                      >
                        <Delete
                          sx={{ color: theme.custom.colors.cancelButton }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Fade>
    </Modal>
  ) : (
    <></>
  );
};

export default ContactTagListModal;
